<script setup lang="ts">
import LanguageSwitcher from './components/LanguageSwitcher.vue'
</script>

<template>
  <main class="paper-page">
    <LanguageSwitcher />
    <RouterView />
  </main>
</template>
